<script>
  import axios from "axios";
  import SlideIt from "svelte-glidejs";
	import Img from "./Img.svelte" 

  import { session } from "./js/notif.js";
  export let description=true;
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  

  import format from "number-format.js";
  //carousel
  let options = {
    type: "carousel",
    direction: "ltr",
    startAt: 0,
    perView: 5,
    breakpoints: {
      320: {
        perView: 2,
      },
      425: {
        perView: 2,
      },
      425: {
        perView: 2,
      },
      768: {
        perView: 3,
      },
      1024: {
        perView: 5,
      },
    },
  };
  let popularproduct;
  $: popularproduct=[];

  $: if (settings) {
    let area="";
  if (localStorage["area"]) {
    area = localStorage["area"];
  }
    axios
      .get(settings.url + "/warga/popularproduct",{
        params: {
          area: area
        }})
      .then(function (response) {
        popularproduct = response.data.data;
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          localStorage.removeItem("t");
          
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: "Anda mungkin harus login kembali",
              color: "orange",
            },
          ];
        } else {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: "Anda belum terhubung dengan baik",
              color: "orange",
            },
          ];
        }
      }); 
  }
</script>

{#if popularproduct.length>0}
  <SlideIt control="true" {options} items={popularproduct}>
    <div slot="item" let:item>
      <a href="product/{item.alias}-{item.ID}">
        <div class="p-1 md:p-2">
          <div
            class="flex flex-col items-center justify-center flex-grow bg-white rounded-lg shadow-sm hover:shadow-lg">
            {#if item.pictures.length > 0}
            <figure>
              <Img id="{item.alias}"
                css="mx-auto block rounded-t-lg"
                alt="{item.alias}"
                datasrc="https://pics.dekatan.com/{item.pictures[0].fileName}" />
            </figure>
            {:else}            
            <figure> 
              <img width="600" height="600"
              id="{item.alias}" class="block mx-auto transition-opacity duration-500 ease-linear rounded-t-lg"
d alt="{item.alias}" src="data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22600%22%20height%3D%22600%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20600%20600%22%20preserveAspectRatio%3D%22none%22%3E%0A%20%20%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%20%20%20%20%20%20%20%20%20%20%23holder%20text%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20fill%3A%20%23eeeeee%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-family%3A%20sans-serif%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-size%3A%2050px%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-weight%3A%20200%3B%0A%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%3C%2Fstyle%3E%0A%20%20%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%20%20%3Cg%20id%3D%22holder%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20width%3D%22100%25%22%20height%3D%22100%25%22%20fill%3D%22%23fafafa%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%3Cg%3E%0A%20%20%20%20%20%20%20%20%20%20%3Ctext%20text-anchor%3D%22middle%22%20x%3D%2250%25%22%20y%3D%2250%25%22%20dy%3D%22.3em%22%3E%5B%20dekatan%20%5D%3C%2Ftext%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fsvg%3E"/> 
            </figure>
            {/if}
            <footer class="flex flex-col justify-center w-full p-3">
              <h2
                class="mb-2 text-xs lg:text-base lg:font-normal ellipsis-2">
                {item.name}
              </h2>
              <h3 class="mb-2 text-xs font-semibold text-orange-700 lg:text-sm">
                {format('Rp #.###,', item.price)},-
              </h3>
              {#if description}
              <p
                class="hidden h-10 text-xs text-gray-700 lg:text-sm lg:block ellipsis-2">
                {item.description}
              </p>
              {/if}
            </footer>
          </div>
        </div>
      </a>
    </div>
  </SlideIt>
{/if}
